export default __webpack_public_path__ + "static/media/ico-neptune-db-score-elevated.e4582c91.svg";